"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.PortalNamesCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var portals = state.portals,
      activePortal = state.activePortal;
  var linkedPortals = state.informationLists.linkedPortals;
  return {
    linkedPortals: linkedPortals,
    portals: portals,
    activePortal: activePortal
  };
};

exports.mapStateToProps = mapStateToProps;

var PortalNamesCell = function PortalNamesCell(_ref) {
  var customerPortalIds = _ref.customerPortalIds,
      linkedPortals = _ref.linkedPortals,
      portals = _ref.portals,
      activePortal = _ref.activePortal;
  var portalNames = [];
  customerPortalIds.forEach(function (portalId) {
    var portal; // check if its is my own portal

    if (parseInt(portalId, 10) === parseInt(activePortal, 10)) {
      portal = portals[portalId];
    } else {
      // if not, it must be from a linked portal
      portal = linkedPortals[portalId];
    }

    if (portal) {
      portalNames.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: "portal-name"
      }, portal.name));
    } else {
      portalNames.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: "no-portal-found"
      }));
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "portal-names-container"
  }, portalNames);
};

exports.PortalNamesCell = PortalNamesCell;
PortalNamesCell.propTypes = {
  customerPortalIds: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  activePortal: _propTypes["default"].number.isRequired,
  linkedPortals: _propTypes["default"].instanceOf(Object).isRequired,
  portals: _propTypes["default"].instanceOf(Object).isRequired
};
PortalNamesCell.defaultProps = {};
var ConnectedPortalNamesCell = (0, _reactRedux.connect)(mapStateToProps)(PortalNamesCell);

var renderer = function renderer(_ref2) {
  var cellData = _ref2.cellData;
  return /*#__PURE__*/_react["default"].createElement(ConnectedPortalNamesCell, {
    customerPortalIds: cellData
  });
};

renderer.propTypes = {
  cellData: _propTypes["default"].string
};
renderer.defaultProps = {
  cellData: ''
};
var _default = renderer;
exports["default"] = _default;